import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { CountryService } from 'src/app/services/country/country.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { BaseComponent } from '../../base/component/base-component';

@Component({
  selector: 'mpp-feature-description',
  templateUrl: './feature-description.component.html',
  styleUrls: ['./feature-description.component.scss'],
  standalone: false,
})
export class FeatureDescriptionComponent extends BaseComponent implements OnInit {
  maxPoints = 100;
  showMobileAppsBanner = true;

  constructor(
    public countryService: CountryService,
    public languageService: LanguageService,
    private analyticsService: AnalyticsService,
  ) {
    super();
  }

  ngOnInit(): void {
    // get and set appStoreLink$ and playStoreLink$
    this.countryService.initializeMobileStoreLinks();

    if (this.countryService.latAmNonRollout()) {
      this.showMobileAppsBanner = false;
    } else {
      this.showMobileAppsBanner = true;
    }
  }

  playStoreLinkClicked(): void {
    this.analyticsService.logPlayStoreRedirect(
      this.countryService.getSelectedCountryId(),
      this.analyticsService.redirectLocationFeatureDescription,
    );
  }

  appStoreLinkClicked(): void {
    this.analyticsService.logAppStoreRedirect(
      this.countryService.getSelectedCountryId(),
      this.analyticsService.redirectLocationFeatureDescription,
    );
  }
}
